import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const DELETE_RECORDING = gql`
  mutation deleteRecording($id: ID!, $workspaceId: ID!) {
    deleteRecording(id: $id, workspaceId: $workspaceId) {
      message
    }
  }
`;
